import React from 'react'
import { ApolloProvider } from '@apollo/client'
import 'isomorphic-fetch'
import '../../utils/lifecycle'
import { getApolloClient } from '../../apollo/apollo-client'
import { OnlineOrderingApp } from './OnlineOrderingApp'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import { QueryClientProvider, QueryClient } from 'react-query'
import { HelmetProvider } from 'react-helmet-async'
import { ErrorComponent } from '@local/do-secundo-error'
import {
  getRestaurantGuidFromWindow,
  getSessionFromWindow
} from '../../utils/window-utils'
import { FeatureFlagProvider } from '@local/do-secundo-feature-flags'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false
    }
  }
})

const AppComponent = ({ isTestMode = false, flags = undefined }) => {
  const restaurantGuid = getRestaurantGuidFromWindow()
  const session = getSessionFromWindow()

  return (
    <ErrorBoundary>
      {restaurantGuid ? (
        <FeatureFlagProvider
          restaurantGuid={restaurantGuid}
          isTestMode={isTestMode}
          mockFlags={flags}
        >
          <ApolloProvider client={getApolloClient(restaurantGuid, session)}>
            <HelmetProvider>
              <QueryClientProvider client={queryClient}>
                <OnlineOrderingApp
                  useMemoryRouter={isTestMode}
                  restaurantGuid={restaurantGuid}
                />
              </QueryClientProvider>
            </HelmetProvider>
          </ApolloProvider>
        </FeatureFlagProvider>
      ) : (
        <ErrorComponent
          error={'There was an error loading the page.'}
          isActionable={false}
          retry={() => window.location.reload()}
        />
      )}
    </ErrorBoundary>
  )
}

export const BanquetApp = AppComponent
